import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { h } from '@debbie/cortex/dist/index.js';
import { useTribunalCasesByCaseId } from '@debbie/cortex/dist/tribunal/index.js';
import { ButtonGroup, Button, Modal } from '../index.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import Table from '../Table.js';
import TribunalCase from './jobs/TribunalCase.js';
import TribunalDocument from './TribunalDocument.js';
import UdbetalingsrekvisitionModal from './UdbetalingsrekvisitionModal.js';
const Tribunal = (props) => {
    const lang = useSelector((s) => s.lang);
    const tribunalCasesLoadable = useTribunalCasesByCaseId(props.case.caseId);
    const tribunalCases = h.hasData(tribunalCasesLoadable)
        ? tribunalCasesLoadable.data
        : null;
    const [addDocumentModalOpen, setAddDocumentModalOpen] = useState(false);
    const [udbetalingsrekvisitionModalOpen, setUdbetalingsrekvisitionModalOpen] = useState(false);
    const toggleAddDocumentModalOpen = () => {
        setAddDocumentModalOpen(!addDocumentModalOpen);
    };
    const toggleUdbetalingsrekvisitionModal = () => {
        setUdbetalingsrekvisitionModalOpen(!udbetalingsrekvisitionModalOpen);
    };
    return (React.createElement("div", null,
        React.createElement("div", null, tribunalCases ? (tribunalCases.length === 0 ? (React.createElement(Placeholder, null, lang.tribunal.noTribunalCases)) : (React.createElement(Table, { zebra: true }, props.case &&
            tribunalCases.map((tribunalCase) => (React.createElement(TribunalCase, { tribunalCase: tribunalCase, caseSeqId: props.case.id, tenantId: props.case.tenantId, key: tribunalCase.id })))))) : (React.createElement(PlaceholderLoader, null))),
        React.createElement("br", null),
        React.createElement(ButtonGroup, { blockOnMobile: true },
            React.createElement(Button, { blockOnMobile: true, theme: "secondary", size: "small", onClick: toggleAddDocumentModalOpen }, lang.tribunal.addFoundation),
            React.createElement(Button, { blockOnMobile: true, theme: "secondary", size: "small", onClick: toggleUdbetalingsrekvisitionModal }, lang.tribunal.requisition)),
        addDocumentModalOpen && (React.createElement(Modal, { onToggle: toggleAddDocumentModalOpen, header: lang.tribunal.addFoundation, maxWidth: "400px" },
            React.createElement(TribunalDocument, { onSubmit: () => {
                    setAddDocumentModalOpen(false);
                }, kase: props.case, creditorId: props.creditorId }))),
        udbetalingsrekvisitionModalOpen && (React.createElement(UdbetalingsrekvisitionModal, { ...props, setModalOpen: setUdbetalingsrekvisitionModalOpen, toggleModal: toggleUdbetalingsrekvisitionModal }))));
};
export default Tribunal;
const Placeholder = styled.h2 `
  text-align: center;
  margin: 2em 0;
  opacity: 0.5;
`;
//# sourceMappingURL=Tribunal.js.map